<template>
  <div class="front-page ">
    <m_header v-if="$store.state.mediaPhone" ></m_header>
    <side_bar :links="links"></side_bar>
    <fp_header></fp_header>
    <activity :activity="activity"></activity>
    <process :process="process"></process>
    <detail :detail="detail"></detail>
    <!-- <video_list :videos="videos"></video_list> -->
    <co_organiser></co_organiser>
  </div>
</template>

<script>
 // @ is an alias to /src
 import SideBar from '@/components/SideBar.vue';
 import FPHeader from '@/components/frontpage/Header.vue';
 import Activity from '@/components/frontpage/Activity.vue';
 import Process from '@/components/frontpage/Process.vue';
 import Detail from '@/components/frontpage/Detail.vue';
 import VideoList from '@/components/frontpage/VideoList.vue';
 import CoOrganiser from '@/components/frontpage/CoOrganiser.vue';

 import HeaderBar from '@/components/HeaderBar.vue';
 /* import infoActiPNG from '@/assets/image/frontpage/header.png';*/

 export default {
   name: 'FrontPage',
   computed: {
     links () {
       return this.$store.state.sbar.linksFP
     },
     activity() {
       return {
         info: this.$store.state.frontpage.info.activity,
         hl: this.$store.state.frontpage.highlights,
       }
     },
     process() {
       return this.$store.state.frontpage.process
     },
     detail () {
       return this.$store.state.frontpage.detail
     },
     videos () {
       return this.$store.state.frontpage.videos
     }
   },
   data () {
     return {
     }
   },
   mounted () {
let devices = ["iPhone","Android","Windows Phone"]
     let ua = window.navigator.userAgent
     console.log(ua)
     for (var i = 0; i < devices.length; i++) {
       if (ua.indexOf(devices[i]) != -1) {
         console.log('match ', devices[i])
         this.$router.replace({name: 'wapfrontpage'})
       }
     }

     /* if(this.$store.state.mediaPhone && !this.$route.query.pc)
      *   {
      *     this.$router.replace({name:'rank', params:{me: 1}})
      *   }*/
     /* this.$http.get('/api/baseinfo')*/
     /* .then(res => {*/
     /* this.process = res.data.process*/
     /* this.detail = {*/
     /* content: res.data.detail,*/
     /* images: this.$store.state.frontpage.detail.images*/
     /* },*/
     /* this.videos = res.data.videos*/
     /* })*/
   },
   components: {
     side_bar: SideBar,
     fp_header: FPHeader,
     activity: Activity,
     process: Process,
     detail: Detail,
     video_list: VideoList,
     co_organiser: CoOrganiser,

     
     m_header:HeaderBar,
   }
 }
</script>

<style scoped>
 .front-page{
   padding: 0;
   margin: 0;
 }
</style>
